import { Controller } from "@hotwired/stimulus"
import { createPopper } from "@popperjs/core"
import debounce from "lodash.debounce"
import * as Routes from "routes"

function findParent(node, callback) {
  while (node && node !== document.body) {
    if (callback(node))
      return node

    node = node.parentElement
  }
}

export default class extends Controller {
  static targets = ["popper", "toolbar"]
  static values = {
    classes: Object
  }

  connect() {
    // Convert classes hash values to array of DOM tokens
    this.htmlClasses = Object.fromEntries(
      Object.keys(this.classesValue).map(k => [k, this.classesValue[k].split(" ")])
    )
  }

  hide() {
    delete this.selection

    if (this.popper) {
      this.popper.destroy()
      delete this.popper
    }

    requestAnimationFrame(() => {
      this.popperTarget.classList.add(...this.htmlClasses.hidden)
    })
  }

  show = () => {
    if (this.popper) {
      this.popperTarget.classList.remove(...this.htmlClasses.hidden)
    }
  }

  updateToolbarLinks(id, type, selection) {
    const args = []
    let route

    if (type === "Agent") {
      route = Routes.new_admin_soc_agent_toolbar_task_path
      args.push(id)
    } else {
      return false
    }

    // Update hrefs for all toolbar links before displaying it
    [...this.toolbarTarget.children].forEach(link => {
      link.href = route(...args, { type: link.dataset.taskType, selection: selection })
    })

    return true
  }

  onSelectionChange = debounce((ev) => {
    const selection = document.getSelection()
    if (!selection || selection.rangeCount === 0) {
      this.hide()
      return
    }

    const range = selection.getRangeAt(0)
    if (!range || range.collapsed) {
      this.hide()
      return
    }

    const { commonAncestorContainer: ancestor } = range
    const node = findParent(ancestor, e => e.nodeType === 1)

    const selectableCtx = findParent(node, e => e.dataset.socSelectionId !== undefined)
    if (!selectableCtx) {
      this.hide()
      return
    }

    // Update toolbar links using metadata about the selection
    const { dataset: { socSelectionId: id, socSelectionType: type } } = selectableCtx
    const toolbarUpdated = this.updateToolbarLinks(id, type, range.toString())

    if (!toolbarUpdated) {
      console.warn(`Unsupport SOC toolbar selection: ${type}`)

      this.hide()
      return
    }

    this.popper = createPopper(node, this.popperTarget, {
      placement: "bottom", modifiers: [{
        name: "offset",
        options: { offset: [0, 12] }
      }]
    })

    this.popper.update()

    requestAnimationFrame(this.show)
  })
}
